import {http, onSuccess, onFail} from './http';

export const updateEpisodePoster = (id, file) => {
    const form = new FormData();
    form.append('poster', file);
    return http.post(`/api/cp/event/stream/episode/${id}/poster`, form)
        .then(onSuccess, onFail);
};

export const removeEpisodePoster = (id) =>
    http.delete(`/api/cp/event/stream/episode/${id}/poster`)
        .then(onSuccess, onFail);
